import React from 'react'
import { Link, useLocation } from 'react-router-dom'

function AccessHistory() {
  const {
    state: { badge },
  } = useLocation()
  console.log(badge)
  const { title, version, accessHistory } = badge
  const options = { year: 'numeric', month: 'long', day: 'numeric' }

  return (
    <div id='AccessHistory' className='px-3'>
      <div className='title mt-4'>Issuance History</div>
      <div className="d-flex justify-content-between">
      <div className='badge-title mt-4'>{title + ' ' + version}</div>
      <div className='mt-4'>Total Issuances: <span className="fw-bold">{accessHistory.length}</span></div>
      </div>
      <div className='accessHistory-wrapper mt-4'>
        {accessHistory.length!==0 ? accessHistory.reverse().map((e, i) => (
          <div className='accessHistory-card hvr-shadow row m-0'>
            <div className='item col-md-3'>
              <div className='meta-title'>Issued To</div>
              <div className='meta-desc'>{e.user.email}</div>
            </div>
            <div className='item col-md-3 mt-2 mt-md-0'>
              <div className='meta-title'>Issued On</div>
              <div className='meta-desc'>{new Date(e.dateIssued).toLocaleDateString('en-GB', options)}</div>
            </div>
            <div className='item col-md-3  mt-2 mt-md-0'>
              <div className='meta-title'>Expires On</div>
              <div className='meta-desc expiration'> {e.expirationDate !== 'never'
                      ? new Date(e.expirationDate).toLocaleDateString('en-GB', options)
                      : 'Never'}</div>
            </div>
            <div className='item col-md-3 d-flex justify-content-center align-items-center  mt-4 mt-md-0'>
            <Link
            target="_blank"
                  className="view-button"
                  to={{
                    pathname: `/user/${e.user.email}`,
                    
                  }}>
                  View User Profile
                </Link>
            </div>

          </div>
        )):( <p className='text-center text-secondary p-5'>No issuances found</p>)}

      </div>
    </div>
  )
}

export default AccessHistory
